import AppointmentMobilePage from "./AppointmentMobilePage";
import AppointmentWebPage from "./AppointmentWebPage";
import useIsMobile from "../../../../hooks/useIsMobile";

const SchedulePage = (props) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <AppointmentMobilePage />;
  } else {
    return <AppointmentWebPage />;
  }
};

export default SchedulePage;
